import { useState } from 'react'
import { useBoolean } from 'react-use'

import { useDeleteProfileMutation } from '@/resolvers/user/mutation'
import { useReqError } from '@/hooks/useReqError'

const useAccountManagement = () => {
  const [showDelete, setShowDelete] = useBoolean(false)
  const [delValue, setDelValue] = useState('')

  const [isDelLoading, setIsDelLoading] = useBoolean(false)
  const [showInfoModal, setShowInfoModal] = useBoolean(false)
  const printAPIError = useReqError()
  const { mutateAsync } = useDeleteProfileMutation()

  const handleDeleteAccount = () => {
    setIsDelLoading(true)
    mutateAsync()
      .then(() => {
        setDelValue('')
        setShowDelete(false)
        setShowInfoModal(true)
      })
      .catch((e) => {
        printAPIError(e)
      })
      .finally(() => {
        setIsDelLoading(false)
      })
  }

  return {
    showDelete,
    delValue,
    handleDeleteAccount,
    isDelLoading,
    setShowDelete,
    setDelValue,
    showInfoModal,
    handleHideInfo: () => setShowInfoModal(false),
  }
}

export default useAccountManagement
